// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Signers_wrapper__1BPVy","addSigner":"Signers_addSigner__3wVOP","addSignerBody":"Signers_addSignerBody__sVGrz"};